<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import './assets/css/public.css'
export default {
  name:'App',
  components:{

  },
  data(){
    return {

    }
  },
  created(){
    // this.getBaseInfo();
    // this.getWebMenuList();
    // console.log(this.$store.state.menulist);
    // if(this.$store.state.menulist.length < 1){
    //   const loading = this.$loading({
    //     lock: true,
    //     text: 'Loading',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(0, 0, 0, 0.7)'
    //   });
    //   setTimeout(() => {
    //     loading.close();
    //   }, 2000);
    // }
  },
  mounted(){
    window.onbeforeunload=()=>{
        //监听刷新事件，刷新时将vuex里的信息保存到sessionStorage里
        sessionStorage.setItem("state",JSON.stringify(this.$store.state));//将当前state存起来
    };
  },
  methods:{
    getBaseInfo(){
        // this.$store.commit("SET_BASEINFO",{});
        //获取基础数据
        this.$axios.get('/wx/baseInfo/searchOne',{})
        .then((response)=>{//获取数据库表数据
          if(response.data.code=="200"){
            var list=response.data.data;
            this.$store.commit("SET_BASEINFO",list);
          }else{
            this.$message({showClose: true,message: response.data.msg,type: 'error'});
          }
        })
        .catch((error)=> {
          console.log(error);
        });
    },
    //获取菜单数据
    getWebMenuList(){
        //根据当前页面模块类型获取对应的菜单列表
      this.$axios.post('/wx/menuinfo/getWebMenulist',{})
      .then((response)=>{//获取数据库表数据
        if(response.data.code=="200"){
          var list=response.data.data;
          var menu=[];
          for (let i in list) {//处理数据库的菜单数据
            var obj={
              id:list[i].id,
              name:list[i].menuName,//菜单名
              parentId:list[i].parentId,//父菜单id
              index:i+'',//index为其下标
              path:{name:list[i].url}
            }
            if(list[i].parentId){//父菜单id处理
              obj.parentId=list[i].parentId;
            }else{
              obj.parentId="";
            }
            if(list[i].url){//有值才赋予url
              obj.path={name:list[i].url};
            }else{
              obj.path={name:""};
            }
            menu.push(obj);
          }
          this.$store.commit("setmenulistdisorder",menu);//菜单列表（未整理）
          var arr2=this.setTreeChild(menu,"");
          this.$store.commit("setmenulist",arr2);//更新菜单列表（已整理）
          this.$store.commit("settaglist",[]);//清空标签列表
        }else{
          this.$message({showClose: true,message: response.data.msg,type: 'error'});
        }
      })
      .catch((error)=> {
        console.log(error);
      });
    },

    setTreeChild(list,parentId){//递归将菜单数据分类整理，返回parentId下的所有子菜单
      var array=[];//存放parentId名下所有的子类
      list.forEach(item=>{//查找parentId名下所有的子类，并添加在array里
        if(item.parentId==parentId){
          var obj=this.setTreeChild(list,item.id);//让当前子类查找它自身名下的子类
          if(obj.length>0){//如果该子类名下也有子类
            item.children=obj;//就将值赋给该子类
          }
          array.push(item);//添加在array里
        }
      });
      return array;//将当前parentId的所有子类返回
    }
  }
}
</script>

<style>
/**
用于设置首页顶部菜单下拉部分的宽度
*/
.el-menu--collapse .el-menu .el-submenu, .el-menu--popup{
  min-width: 120px!important;
}
</style>
